import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';

import { HomeCloseWelcomeChannel } from '../../app/actions/AppActionTypes';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { Messages } from '../../codegen/Localize';
import { showActionableToast } from '../../common/react/components/ActionableMessage';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { GetServerWelcomeChannelInfoRequest, GetServerWelcomeChannelInfoResult } from '../../ts/ServerApi/requests/GetServerWelcomeChannelInfoRequest';
import { SetShowWelcomeScreenRequest } from '../../ts/ServerApi/requests/SetShowWelcomeScreenRequest';
import { ToastType } from '../../ts/services/ToasterService';
import { getServerWelcomeChannelInfoSucceededAction } from '../actions/HomeActions';

export function* homeCloseWelcomeChannel() {
  try {
    yield call(sendCloseWelcomeScreenRequest);
    yield call(showDismissedWelcomeChannelToast);
  }
  catch(e) {
    // TODO: Fire off a failure log, we don't want to display a toast to the user in this case.
    yield call(logHomeFailure);
  }
}

// This could be refactored to sendShowWelcomeScreenRequest(boolean) to allow showing/hiding in the future
export function sendCloseWelcomeScreenRequest(): Promise<IResult> {
  return WebHttpClient.sendRequest(new SetShowWelcomeScreenRequest({ showWelcomeScreen: false }));
}

export function showDismissedWelcomeChannelToast() {
  showActionableToast({
    testId: 'dismissed-welcome-channel-success',
    message: Messages.home_welcomeChannel_dismissed_toast(),
    actionMessage: Messages.changeSettings(),
    action: linkToMyAccountSettings
  }, ToastType.Success);
}

function linkToMyAccountSettings(): void {
  const sessionManagementService = getSessionManagementServiceInstance();
  const siteUrls = new SpacesSiteUrls({
    siteUrlName: sessionManagementService.sessionSiteUrlName(),
  });
  const link = siteUrls.userSettingsUrl(sessionManagementService.sessionUsername(), sessionManagementService.sessionUserDomainName());
  WindowLocationService.navigateTo(link);
}

export function* fetchServerWelcomeChannelInfo() {
  if (FeatureFlags.serverWelcomeChannelEnabled) {
    const result = yield call(sendGetServerWelcomeChannelInfoRequest);
    yield put(getServerWelcomeChannelInfoSucceededAction(result));
  }
}

export function sendGetServerWelcomeChannelInfoRequest(): Promise <GetServerWelcomeChannelInfoResult> {
  return WebHttpClient.sendRequest(new GetServerWelcomeChannelInfoRequest());
}

export function logHomeFailure() {
  // TODO: Will be implemented when we figure out how we want to do monitoring.
}

export function* rootHomeSaga(): SagaIterator {
  yield takeEvery(HomeCloseWelcomeChannel, homeCloseWelcomeChannel);
}
